import React from 'react'
import CustomInvoicesNew from '../CustomInvoices/CustomInvoices_new'
import { useCustomInvoiceStore } from '../../store/CustomInvoicesStore'


const CustomInvoicesWrapper = (props) => {
  const invoiceStore = useCustomInvoiceStore()
  
  return (
      <CustomInvoicesNew invoiceStore={invoiceStore} {...props}/>
  )
}

export default CustomInvoicesWrapper